var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TaskModelViewer',{attrs:{"newTab":true,"visible":_vm.modelViewVisible,"file":_vm.viewFile},on:{"update:visible":function($event){_vm.modelViewVisible=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }